import { RUNES_REGION_TYPES } from '@frontend/api';

import type { FindingData } from '../types';
import type { ActionResolution } from './types';

type CopyActionProps = {
  label: string;
  tooltipPlacement: 'top' | 'bottom' | 'left' | 'right';
};

const EXCLUDED_REGION_TYPES = [
  RUNES_REGION_TYPES.TITLE_BLOCK,
  RUNES_REGION_TYPES.VIEW_2D,
  RUNES_REGION_TYPES.VIEW_3D,
  RUNES_REGION_TYPES.NOTES_LIST,
];

export const useCopyAction = (
  finding: FindingData | null,
  tooltipPlacement: 'top' | 'bottom' | 'left' | 'right' = 'top',
): ActionResolution<CopyActionProps> => {
  if (!finding) return { enabled: false, label: '', tooltipPlacement };

  const { regionType, label } = finding;
  if (regionType && EXCLUDED_REGION_TYPES.includes(regionType)) {
    return { enabled: false, label: '', tooltipPlacement };
  }

  return { enabled: true, label, tooltipPlacement };
};
